"use strict";

let currentSnackBarId = 0;
window.showSnackbar = (message, kind, duration = 3600) => {
  const setSnackbarDuration = (snackbarSelector, duration) => {
    setTimeout(() => {
      const snackbarEl = document.querySelector(snackbarSelector);
      snackbarEl.classList.remove('is-active');
      setTimeout(() => {
        snackbarEl.parentNode.removeChild(snackbarEl);
      }, 1000);
    }, duration);
  };
  const snackBarTemplate = document.querySelector('#snackBarTemplate');
  const snackBarsWrap = document.querySelector('#snackBarsWrap');
  const importedSnackBar = document.importNode(snackBarTemplate.content, true);
  const snackBar = importedSnackBar.querySelector('.snackbar');
  const snackBarId = `snackbar_${currentSnackBarId}`;
  snackBar.setAttribute('id', snackBarId);
  snackBar.classList.add(`is-${kind}`);
  snackBar.querySelector('.snackbar__message').innerHTML = message;
  snackBarsWrap.appendChild(snackBar);
  setSnackbarDuration(`#${snackBarId}`, duration);
  currentSnackBarId += 1;
};